import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiClient } from '../../../../api-client';
import { UnitResult } from '../../../../error';
import {
    ApplyToJobShiftsRequest,
    ApplyToJobShiftsService
} from '../../../Domain/Port/ApplyToJobShifts/apply-to-job-shifts.service';
import { ApplyToJobShiftsBackendRequest } from './Model/apply-to-job-shifts-request';

@Injectable({
    providedIn: 'root'
})
export class BackendApplyToJobShiftsService extends ApplyToJobShiftsService {
    private readonly endpoint = '/jobs/{id}/apply';

    constructor(private apiClient: ApiClient) {
        super();
    }

    override applyToJobShifts(request: ApplyToJobShiftsRequest): Observable<UnitResult<void>> {
        const backendRequest = new ApplyToJobShiftsBackendRequest(request);
        const url = this.endpoint.replace('{id}', request.jobID.toString());
        return this.apiClient.post<ApplyToJobShiftsBackendRequest, void>(url, backendRequest, true);
    }
}
